import { useIsAccrualLedgerEnabled } from "@hooks/useIsAccrualLedgerEnabled";
import { useMemo } from "react";
import { useEntities } from "@hooks/useEntities";
import { useIsClassesEnabled } from "@hooks/useIsClassesEnabled";
import { useCanUseInvoicing } from "@hooks/useCanUseInvoicing";
import { useMultiLedgerColumns } from "@hooks/useMultiLedgerColumns";
import { useIsRecognitionScheduleColumnEnabled } from "@hooks/useIsRecognitionScheduleColumnEnabled";
import { useIsGlFirst } from "@hooks/useIsGlFirst";
import { createTransactionsViewConfig } from "./transactionsViewConfig";

export function useTransactionViewConfig() {
    return useTransactionViewConfigState().transactionsViewConfig;
}

export function useTransactionViewConfigState() {
    const isAccrualLedgerEnabled = useIsAccrualLedgerEnabled();
    const isClassesEnabled = useIsClassesEnabled();
    const isInvoicingEnabled = useCanUseInvoicing();
    const isSchedulesEnabled = useIsRecognitionScheduleColumnEnabled();
    const { enabled: isGlFirst } = useIsGlFirst();
    const entities = useEntities({ onlyBusiness: true });
    const entityIds = useMemo(
        () => entities.map((entity) => entity.id),
        [entities],
    );
    const multiLedgerLedgers = useMultiLedgerColumns(entityIds, {
        uniqueByBasisAndName: true,
    });

    const transactionsViewConfig = useMemo(
        () =>
            createTransactionsViewConfig({
                isAccrualLedgerEnabled,
                isGlFirst,
                isSchedulesEnabled,
                isClassesEnabled,
                isInvoicingEnabled,
                multiLedgerLedgers,
            }),
        [
            isAccrualLedgerEnabled,
            isClassesEnabled,
            isGlFirst,
            isInvoicingEnabled,
            isSchedulesEnabled,
            multiLedgerLedgers,
        ],
    );

    return useMemo(
        () => ({ transactionsViewConfig }),
        [transactionsViewConfig],
    );
}
